// PARAQTA — кітап мұқабасы көмекшілері.
//
// Step LH1: cover_url болмаса — бренд placeholder
// (brown gradient + Cormorant italic title + gold line + uppercase
// author). Бұрынғы 8 түрлі rainbow gradient — біркелкі brown PARAQTA
// жанымен ауыстырылды. ICONS / COVER_GRADIENTS әлі экспортталмайды,
// тек бар constants файлы бұзылмауы үшін сақталды.

import { esc } from './format.js';

// bookIcon — кітап эмодзи (📕 📗 📘 📙) бір сурет/icon керек жерде.
// Brand placeholder-да emoji жоқ — бірақ icon тағы басқа жерлерде
// (кітап карточкасы т.б.) қолданылуы мүмкін, сондықтан сақтаймыз.
const BOOK_EMOJIS = ['📗', '📕', '📘', '📙'];

export function bookIcon(t) {
  let h = 0;
  for (let c of (t || '')) h = (h * 31 + c.charCodeAt(0)) & 0xffff;
  return BOOK_EMOJIS[h % BOOK_EMOJIS.length];
}

// coverGradient — бұрын title/author-ден hash жасап random gradient
// таңдайтын. Енді бренд placeholder-ге біркелкі — әрқашан 'cov-pq'.
// Бар callers (dawys cards т.б.) міндетті өзгеріссіз.
export function coverGradient(_title, _author) {
  return 'cov-pq';
}

export function coverBox(title, author, coverUrl) {
  // Кітап cover контейнерінің inner HTML-ін қайтарады.
  // coverUrl бар болса → <img>; болмаса → бренд placeholder.
  if (coverUrl) {
    return '<img src="' + esc(coverUrl) + '" alt="' + esc(title || '') + '" loading="lazy">';
  }
  return '<div class="cov-pq" style="position:absolute;inset:0"></div>' +
    '<div class="cover-label">' +
      '<div class="cover-label-title">' + esc(title || '') + '</div>' +
      '<div class="cover-label-line"></div>' +
      (author ? '<div class="cover-label-author">' + esc(author) + '</div>' : '') +
    '</div>';
}
